export enum PlatformBillingPermission {
  view = "platformBilling.view",
  manage = "platformBilling.manage",
}
